import React from 'react';
import PropTypes from 'prop-types';

const EqualsIcon = ({color = 'currentColor', ...props}) => (
  <svg
    width="15"
    height="9"
    viewBox="0 0 15 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.1673 7.49992H0.833984M14.1673 0.833252H0.833984"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
    />
  </svg>
);

EqualsIcon.propTypes = {
  color: PropTypes.string,
};

export default EqualsIcon;
